export enum StatType {
  Average = 'average',
  Count = 'count',
  Percentage = 'percentage',
}
